import { inject, signal } from '@angular/core';
import { AppStateService, StationsService } from '../../../services';
import { StationCartItem } from '../../../models';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationOptionsClass {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  router = inject(Router);
  appState = inject(AppStateService);

  items = signal<StationCartItem[]>([]);
  routes = PublicRoutes;

  init() {
    this.setItems();
  }

  setItems() {
    const items: StationCartItem[] = [];
    const selectedStation = this.stationsService.getSelectedStation();
    const max = selectedStation?.MaxUsers
      ? selectedStation.MaxUsers - 1
      : 0;

    items.push({
      ...this.stationsService.getGuestItem()!,
      cartQty: this.stationsService.getSelectedAmountOfGuests(),
      subDescription: `Please enter the number of Additional Shooters you are expecting. (Not counting you). $${this.stationsService.getGuestItem()!.Price} per Additional Shooter`,
      max: max,
    });

    if (this.stationsService.getSelectedNeedsRSO()) {
      items.push({
        ...this.stationsService.getSelectedRangeSafteyOfficer()!,
        subDescription: `Range Officer $${this.stationsService.getRSOItem()!.Price} per Hour`,
        max: 23,
      });
    }

    this.items.set(items);
  }

  onNextClick() {
    const guestItem = this.items().find((item) =>
      item.Category === this.appState.stationSettings.guestCat && item.SubCategory === this.appState.stationSettings.guestSubCat
    )!;

    this.stationsService.setSelectedAmountOfGuests(guestItem.cartQty);
    if (this.stationsService.getSelectedNeedsRSO()) {
      this.stationsService.removeItem(this.stationsService.getSelectedRangeSafteyOfficer()!);
      this.stationsService.addItem(this.stationsService.getSelectedRangeSafteyOfficer()!);
    } else {
      this.stationsService.removeItem(this.stationsService.getSelectedRangeSafteyOfficer()!);
    }

    if (this.stationsService.getSelectedAmountOfGuests() > 0) {
      this.stationsService.removeItem(this.stationsService.getGuestItem()!);
      this.stationsService.addItem({
        ...this.stationsService.getGuestItem()!,
        cartQty: this.stationsService.getSelectedAmountOfGuests(),
      });
    } else {
      this.stationsService.removeItem(this.stationsService.getGuestItem()!);
    }

    this.router.navigate([this.routes.STATIONS, this.routes.CHECKOUT]);
  }

  isRsoItem(item: StationCartItem) {
    return item.Category === this.appState.stationSettings.rsoCat && item.SubCategory === this.appState.stationSettings.rsoSubCat;
  }
}